import SharedPerguntasEssenciaisSection from '../_shared/PerguntasEssenciaisSection';
import { CATALOGO, LIMITE_ATIVAS, LIMITE_QUALIF } from './perguntas/catalog';
import { TIPOS_IMOVEL, buildInitialWorkflow } from './perguntas/tiposImovel';

/**
 * Wrapper do vertical imobiliário sobre o motor de coleta compartilhado.
 *
 * O motor (section + canvas ReactFlow + drawer + linha de pergunta) foi movido
 * para `_shared/` sem mudança de comportamento; o que é do vertical — catálogo
 * de perguntas, tipos de imóvel, limites e textos — continua aqui e é injetado
 * por prop. `moduleKey='realstate'` (sem o 'e') e os `i18nBase` reproduzem
 * exatamente os prefixos que já existem em settings.json.
 */
export default function PerguntasEssenciaisSection({ aiAgent, changeModuleConfig }) {
    return (
        <SharedPerguntasEssenciaisSection
            aiAgent={aiAgent}
            changeModuleConfig={changeModuleConfig}
            moduleKey="realstate"
            catalogo={CATALOGO}
            itensAdicionaveis={TIPOS_IMOVEL}
            buildInitialWorkflow={buildInitialWorkflow}
            limiteAtivas={LIMITE_ATIVAS}
            limiteQualif={LIMITE_QUALIF}
            i18nBase="aiAgents.realstate.perguntasEssenciais."
            i18nPerguntas="aiAgents.realstate.perguntas."
        />
    );
}
